import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm$user$delivery_add, _vm$getCurrentOrder;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.firstConnection ? _c("div", {
    staticClass: "first-connection-intro"
  }, [_vm._v(" Please finish updating your account information to continue. ")]) : _vm._e(), !_vm.firstConnection && (_vm.isBuyerGroup(_vm.user.user_group) || _vm.isConsultantOrHolding(_vm.loggedUserData)) ? _c("div", {
    staticClass: "profile-status"
  }, [_c("h2", [_vm._v("My privilege status")]), _c("div", {
    staticClass: "flex flex-column items-stretch"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1 mt-2",
    staticStyle: {
      "max-width": "55rem"
    },
    attrs: {
      headers: _vm.accountStatusHeaders,
      items: _vm.listCategoryUser,
      "items-per-page": -1,
      "loading-text": "Loading... Please wait",
      "hide-default-header": "",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.id",
      fn: function fn(_ref) {
        var _vm$accountStatus;
        var item = _ref.item;
        return [item.id === ((_vm$accountStatus = _vm.accountStatus) === null || _vm$accountStatus === void 0 ? void 0 : _vm$accountStatus.rangeAccessibility) ? _c("div", [_c(VIcon, {
          staticClass: "fas fa-long-arrow-alt-right text-success",
          attrs: {
            size: "40"
          }
        })], 1) : _vm._e()];
      }
    }, {
      key: "item.textForUsers",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c("div", {
          staticStyle: {
            "padding-top": "0.66rem",
            "padding-bottom": "0.8rem"
          }
        }, [_c("div", {
          staticClass: "text-bold text-bigger",
          staticStyle: {
            "text-transform": "capitalize"
          }
        }, [_vm._v(" " + _vm._s(item.textForUsers) + " ")]), _c("div", {
          staticClass: "text-bigger"
        }, [_vm._v(_vm._s(item.description))]), item.textWaitingAccessCategory ? _c("div", [_vm._v(" " + _vm._s(item.textWaitingAccessCategory) + " ")]) : _vm._e(), _c("div", {
          staticClass: "text-smaller text-italic"
        }, [_vm._v(_vm._s(_vm.additionalDescription(item)))]), _c("div", {
          staticClass: "mt-1"
        }, [_c(VBtn, {
          staticClass: "dfwa-btn --small-2 secondary",
          attrs: {
            rounded: "",
            to: _vm.goToWinesFiltered(item)
          }
        }, [_c(VIcon, {
          staticClass: "fa fa-eye mr-1",
          attrs: {
            size: "0.65rem"
          }
        }), _vm._v(" Explore wine selection ")], 1)], 1)])];
      }
    }], null, true)
  }), _c("div", {
    staticClass: "text-right text-smaller text-italic"
  }, [_c("a", {
    staticClass: "text-smaller",
    on: {
      click: function click($event) {
        return _vm.openToS("#privilege-offer");
      }
    }
  }, [_vm._v("How does it work ?")])])], 1)]) : _vm._e(), _c("div", {
    staticClass: "profile-container"
  }, [_c("div", [_c("h2", [_vm._v("My personal information")]), _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Login",
      placeholder: "john.doe@domain.com"
    },
    model: {
      value: _vm.user.login,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "login", $$v);
      },
      expression: "user.login"
    }
  }), _vm.errorLabels.login.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.login) + " ")]) : _vm._e()], 1), _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "First name",
      placeholder: "John"
    },
    model: {
      value: _vm.user.name,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "name", $$v);
      },
      expression: "user.name"
    }
  }), _vm.errorLabels.name.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.name) + " ")]) : _vm._e()], 1), _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Last name",
      placeholder: "Doe"
    },
    model: {
      value: _vm.user.nickname,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "nickname", $$v);
      },
      expression: "user.nickname"
    }
  }), _vm.errorLabels.nickname.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.nickname) + " ")]) : _vm._e()], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isUserIndividual,
      expression: "!isUserIndividual"
    }]
  }, [_c(VTextField, {
    class: _vm.user.user_group == "HORECA" || _vm.user.user_group == "WHOLESALER" || _vm.user.isHolding ? "required" : "",
    attrs: {
      label: "Company name",
      placeholder: "Company name"
    },
    model: {
      value: _vm.user.company_name,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "company_name", $$v);
      },
      expression: "user.company_name"
    }
  }), _vm.errorLabels.company_name.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.company_name) + " ")]) : _vm._e()], 1), _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Phone number",
      placeholder: "+33686868686"
    },
    model: {
      value: _vm.user.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "phone", $$v);
      },
      expression: "user.phone"
    }
  }), _vm.errorLabels.phone.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.phone) + " ")]) : _vm._e()], 1)]), _c("div", [_c("h2", [_vm._v("Additional information")]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isUserIndividual,
      expression: "!isUserIndividual"
    }]
  }, [_c(VTextField, {
    class: _vm.user.user_group == "HORECA" || _vm.user.user_group == "WHOLESALER" ? "required" : "",
    attrs: {
      label: _vm.taxIdLabel,
      placeholder: "FR99999999999"
    },
    model: {
      value: _vm.user.vat_code,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "vat_code", $$v);
      },
      expression: "user.vat_code"
    }
  }), _vm.errorLabels.vat_code.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.vat_code) + " ")]) : _vm._e()], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isUserIndividual,
      expression: "!isUserIndividual"
    }]
  }, [_c(VTextField, {
    class: (_vm.user.user_group === "HORECA" || _vm.user.user_group === "WHOLESALER") && (_vm.user.delivery_address.country.iso_code === "USA" || _vm.user.delivery_address.country.iso_code === "BRA") ? "required" : "",
    attrs: {
      label: _vm.liquorNumberLabel,
      placeholder: ""
    },
    model: {
      value: _vm.user.excise_code,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "excise_code", $$v);
      },
      expression: "user.excise_code"
    }
  }), _vm.errorLabels.excise_code.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.excise_code) + " ")]) : _vm._e()], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isUserIndividual,
      expression: "isUserIndividual"
    }]
  }, [_c(VTextField, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm$user$delivery_add = _vm.user.delivery_address) === null || _vm$user$delivery_add === void 0 || (_vm$user$delivery_add = _vm$user$delivery_add.country) === null || _vm$user$delivery_add === void 0 ? void 0 : _vm$user$delivery_add.iso_code) == "BRA",
      expression: "user.delivery_address?.country?.iso_code == 'BRA'"
    }],
    attrs: {
      label: _vm.individualCodeLabel,
      "hide-details": "auto",
      placeholder: ""
    },
    model: {
      value: _vm.user.individualCode,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "individualCode", $$v);
      },
      expression: "user.individualCode"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Contact additional information",
      placeholder: "Please contact me between 6 and 9pm"
    },
    model: {
      value: _vm.user.contact,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "contact", $$v);
      },
      expression: "user.contact"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Contact email address",
      placeholder: "Your specific contact email address"
    },
    model: {
      value: _vm.user.contactEmail,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "contactEmail", $$v);
      },
      expression: "user.contactEmail"
    }
  }), _vm.errorLabels.contactEmail.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.contactEmail) + " ")]) : _vm._e()], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Billing email address",
      placeholder: "Your billing email address"
    },
    model: {
      value: _vm.user.billingEmail,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "billingEmail", $$v);
      },
      expression: "user.billingEmail"
    }
  }), _vm.errorLabels.billingEmail.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.billingEmail) + " ")]) : _vm._e()], 1), _c("div", [_vm.isConsultant ? _c(VTextField, {
    attrs: {
      label: "Your consultant code",
      readonly: ""
    },
    model: {
      value: _vm.user.consultant_code,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "consultant_code", $$v);
      },
      expression: "user.consultant_code"
    }
  }) : _vm._e()], 1), _c("div", [!!_vm.user.sponsorship_code ? _c(VTextField, {
    attrs: {
      label: "Keypass",
      readonly: ""
    },
    model: {
      value: _vm.user.sponsorship_code,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "sponsorship_code", $$v);
      },
      expression: "user.sponsorship_code"
    }
  }) : _vm._e()], 1), _c("div", [_c(VAutocomplete, {
    attrs: {
      label: "Currency",
      items: _vm.listDefaultCurrencies,
      "item-value": "id",
      "item-text": "name",
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto",
      readonly: !_vm.canChangeCurrency
    },
    model: {
      value: _vm.user.default_currency,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "default_currency", $$v);
      },
      expression: "user.default_currency"
    }
  })], 1), _vm.canChangeCurrency && ((_vm$getCurrentOrder = _vm.getCurrentOrder()) === null || _vm$getCurrentOrder === void 0 || (_vm$getCurrentOrder = _vm$getCurrentOrder.items) === null || _vm$getCurrentOrder === void 0 ? void 0 : _vm$getCurrentOrder.length) > 0 ? _c("div", {
    staticClass: "text-italic text-sm"
  }, [_vm._v(" Changing the currency here will empty the cart. You can change it directly on the "), _c("router-link", {
    attrs: {
      title: "Open cart",
      to: _vm.routeFinalizeCart()
    }
  }, [_vm._v("cart")]), _vm._v(" page. ")], 1) : _vm._e()]), _c("div", [_c("h2", [_vm._v("My delivery address")]), _c("div", [_c("address-user", {
    ref: "addressDelivery",
    attrs: {
      baseModel: _vm.user.delivery_address,
      listCountries: _vm.listCountriesForDeliveryAddress,
      listStates: _vm.listStates,
      readOnly: false,
      showDeliveryInstructions: true
    },
    on: {
      change: _vm.changeDeliveryAddress
    }
  })], 1)]), _c("div", [!_vm.hide_billing_address ? _c("div", [_c("h2", [_vm._v("My billing address")]), _c("div", [_c("address-user", {
    ref: "addressBilling",
    attrs: {
      baseModel: _vm.user.billing_address,
      listCountries: _vm.listCountries,
      listStates: _vm.listStates,
      readOnly: false
    },
    on: {
      change: _vm.changeBillingAddress
    }
  })], 1)]) : _vm._e(), _c(VCheckbox, {
    staticStyle: {
      width: "fit-content"
    },
    attrs: {
      dark: _vm.firstConnection,
      label: "My billing address is the same"
    },
    on: {
      change: function change() {
        return _vm.changeBillingAddress(_objectSpread(_objectSpread({}, _vm.user.billing_address.country), {}, {
          instanceof: "country"
        }), true);
      }
    },
    model: {
      value: _vm.hide_billing_address,
      callback: function callback($$v) {
        _vm.hide_billing_address = $$v;
      },
      expression: "hide_billing_address"
    }
  })], 1), !_vm.firstConnection ? _c("div", [_c("h2", [_vm._v("Change password")]), _c("div", [_c(VTextField, {
    attrs: {
      label: "Password",
      type: _vm.isShowPassword ? "text" : "password",
      autocomplete: "new-password",
      "hide-details": "auto"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c("span", {
          attrs: {
            tabindex: "-1"
          },
          on: {
            click: function click($event) {
              _vm.isShowPassword = !_vm.isShowPassword;
            }
          }
        }, [!_vm.isShowPassword ? _c(VIcon, [_vm._v("mdi-eye")]) : _c(VIcon, [_vm._v("mdi-eye-off")])], 1)];
      },
      proxy: true
    }], null, false, 1963429649),
    model: {
      value: _vm.input.new_password,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "new_password", $$v);
      },
      expression: "input.new_password"
    }
  }), _vm.errorLabels.new_password.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.new_password) + " ")]) : _vm._e()], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Confirm password",
      type: _vm.isShowPassword ? "text" : "password",
      autocomplete: "new-password",
      "hide-details": "auto"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c("span", {
          staticClass: "cursor--pointer",
          on: {
            click: function click($event) {
              _vm.isShowPassword = !_vm.isShowPassword;
            }
          }
        }, [!_vm.isShowPassword ? _c(VIcon, [_vm._v("mdi-eye")]) : _c(VIcon, [_vm._v("mdi-eye-off")])], 1)];
      },
      proxy: true
    }], null, false, 3100851295),
    model: {
      value: _vm.input.password_confirm,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "password_confirm", $$v);
      },
      expression: "input.password_confirm"
    }
  }), _vm.errorLabels.password_confirm.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.password_confirm) + " ")]) : _vm._e()], 1)]) : _vm._e()]), _c("div", {
    staticClass: "button-end-page-container"
  }, [!_vm.firstConnection && !_vm.isAdminNotConsultant ? _c(VBtn, {
    staticClass: "dfwa-btn secondary",
    style: _vm.btnStyle,
    attrs: {
      rounded: true
    },
    on: {
      click: _vm.deleteAccount
    }
  }, [_vm._v(" Delete account ")]) : _vm._e(), _c(VBtn, {
    staticClass: "dfwa-btn",
    style: _vm.btnStyle,
    attrs: {
      rounded: true
    },
    on: {
      click: _vm.updateAccount
    }
  }, [_vm._v("Save")])], 1), _c("confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };